module.exports = __webpack_public_path__ + "static/media/Balancing_Tube_1_5ml_LT.d1144c91.svg";